import React from 'react';
import NumericInput from 'react-numeric-input';
import { mobileStyle } from './InputStyles';

const NumberInput = (props) => {
  return <NumericInput {...props} style={mobileStyle} />;
};
export default NumberInput;
